import {Alert, Typography} from "@material-tailwind/react";
import React from "react";

export function AgentServiceCheckHeaderAlert() {
  return (
    <Alert className="mt-8 w-full px-0" variant="gradient">
      <Typography variant="h5" className="mb-4">
        مشاور گرامی، لطفا قبل از هر گونه اقدام نکات زیر را مطالعه نمائید؛
      </Typography>
      <Typography variant="body" color="">
        <li>
          لطفا در ارائه قیمت و زمان انجام فرآیند خدمت دقت کافی و لازم را بعمل آورید، هر گونه اشتباه
          در قیمت گذاری خدمات و تاخیر در تعداد روز انجام خدمت مشمول جریمه و خسارت به کاربر متقاضی خدمت
          خواهد بود.
        </li>
      </Typography>
      <Typography variant="body" color="">
        <li>
          دکمه تائید پرداخت پس از بررسی مدارک و تائید مدارک ارسالی از سوی متقاضی، توسط شما فعال
          خواهد شد.
        </li>
      </Typography>
      <Typography variant="body" color="">
        <li>
          اگر برای قیمت گذاری بهتر نیاز به تماس با کاربر را دارید، با کلیک بر روی دکمه تماس با
          کاربر، تماس فی مابین بصورت خودکار برقرار خواهد شد.
        </li>
      </Typography>
      <Typography variant="body" color="">
        <li>
          در صورت نیاز به مدارک و مستندات بیشتر می توانید با کلیک بر روی دکمه جدید درخواست مدارک
          بیشتری نمائید.
        </li>
      </Typography>
    </Alert>
  )
}
